import type { FC } from 'react';
import { Option } from '../option';
import { Switch } from 'src/common/components/switch';
import { useCurrentUser, useUpdateUser } from 'src/hooks/user';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const NotificationSetting: FC = () => {
  const { t } = useAppTranslation();
  const user = useCurrentUser();
  const updateUser = useUpdateUser();

  if (!user) return null;
  return (
    <>
      <div className="text-t2">{t('components.setting_modal.notification.title')}</div>
      <Option
        showSplitLine={false}
        title={t('common.collaboration_notification')}
        description={t('components.setting_modal.notification.collaboration.description')}
        rightPart={
          <Switch
            open={!user.setting.closeCollaborativeNotification}
            onSwitch={(status) => {
              void updateUser({
                setting: {
                  closeCollaborativeNotification: !status,
                },
              });
            }}
          />
        }
      />
      <Option
        showSplitLine={false}
        title={t('common.share_notification')}
        description={t('components.setting_modal.notification.share.description')}
        rightPart={
          <Switch
            open={!user.setting.closeShareNotification}
            onSwitch={(status) => {
              void updateUser({
                setting: {
                  closeShareNotification: !status,
                },
              });
            }}
          />
        }
      />
      <Option
        showSplitLine={false}
        title={t('common.subscribe_notification')}
        description={t('components.setting_modal.notification.subscribe.description')}
        rightPart={
          <Switch
            open={!user.setting.closeSubscribeNotification}
            onSwitch={(status) => {
              void updateUser(
                {
                  setting: {
                    closeSubscribeNotification: !status,
                  },
                },
                true
              );
            }}
          />
        }
      />
      <Option
        showSplitLine={false}
        title={t('components.setting_modal.notification.inbox.title')}
        description={t('components.setting_modal.notification.inbox.description')}
        rightPart={
          <Switch
            open={!user.setting.closeInboxNotification}
            onSwitch={(status) => {
              void updateUser({
                setting: {
                  closeInboxNotification: !status,
                },
              });
            }}
          />
        }
      />
      {__BUILD_IN__ && (
        <Option
          showSplitLine={false}
          title={t('components.setting_modal.notification.email.title')}
          description={t('components.setting_modal.notification.email.description')}
          rightPart={
            <Switch
              open={user.setting.emailNotification ?? true}
              onSwitch={(status) => {
                void updateUser({
                  setting: {
                    emailNotification: status,
                  },
                });
              }}
            />
          }
        />
      )}
    </>
  );
};
